import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { QuizQuestionType } from '../../enums/quiz-question-type.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'quizQuestionType',
  standalone: false
})
export class QuizQuestionTypePipe implements PipeTransform {
  public transform(value: QuizQuestionType): string {
    return getQuizQuestionType(value);
  }
}

export function getQuizQuestionType(value: QuizQuestionType): string {
  switch (value) {
    case QuizQuestionType.Checkbox:
      return 'Multiple Choice';
    default:
      throw new Error(`Unsupported value for QuizQuestionType: ${value}.`);
  }
}

export function getQuizQuestionTypeList(): IdName[] {
  return enumToList(QuizQuestionType, getQuizQuestionType);
}
